import BaseLayout from '@/views/layouts/BaseLayout.vue';

import ProjectDetails from '@/views/ProjectDetails.vue';
import NewProject from '@/views/NewProject.vue';

import TasksList from '@/views/project-details/TasksList.vue';
import IssuesList from '@/views/project-details/IssuesList.vue';
import GeneralInformation from '@/views/project-details/GeneralInformation.vue';
import TechnicalInformation from '@/views/project-details/TechnicalInformation.vue';

import { views } from '@/router/constants';
import AutomaticProjectIssuesList from '@/views/project-details/AutomaticProjectIssuesList.vue';

export default [
  {
    path: '/new-project',
    component: BaseLayout,
    children: [
      {
        path: '/create-project',
        name: views.NEW_PROJECT,
        component: NewProject,
      },
    ],
  },
  {
    path: '/activity-log/:id',
    name: views.PROJECT_DETAILS,
    component: ProjectDetails,
    redirect: route => ({ name: route.params.to }),
    props: route => ({ id: route.params.id }),
    children: [
      {
        path: 'general',
        name: views.PROJECT_GENERAL_INFORMATION,
        component: GeneralInformation,
      },
      {
        path: 'technical-information',
        name: views.PROJECT_TECHNICAL_INFORMATION,
        component: TechnicalInformation,
      },
      {
        path: 'work-with-project',
        name: views.PROJECT_WORK_WITH_PROJECT,
        component: TasksList,
      },
      {
        path: 'issues',
        name: views.PROJECT_FINDINGS,
        redirect: { name: views.PROJECT_ISSUES },
      },
      {
        path: 'issues',
        name: views.PROJECT_ISSUES,
        component: IssuesList,
      },
      {
        path: 'automatic-issues',
        name: views.AUTOMATIC_PROJECT_ISSUES,
        component: AutomaticProjectIssuesList,
      },
    ],
  },
];
